import React, { FC, useEffect, useRef, useState } from 'react'

export interface FormConfig<T extends Record<string, string>> {
  url: string
  values: T
}

export interface HiddenFormReturn<T extends Record<string, string>> {
  HiddenForm: FC
  submitForm: (config: FormConfig<T>) => void
}

function useHiddenForm<
  T extends Record<string, string>,
>(): HiddenFormReturn<T> {
  const [config, setConfig] = useState<FormConfig<T> | null>(null)
  const formSubmitButton = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (!config) return
    formSubmitButton.current?.click()
  }, [config])

  const HiddenForm: FC = () => (
    <form method="post" action={config?.url} hidden>
      {Object.entries(config?.values ?? {}).map(([key, value]) => (
        <input type="hidden" name={key} key={key} value={value} />
      ))}
      <input ref={formSubmitButton} type="submit" value="Submit" />
    </form>
  )

  return {
    HiddenForm,
    submitForm: setConfig,
  }
}

export default useHiddenForm
